<template>
  <div>
    <div class="content">
      <div class="content-left">
        <div title="风险等级动态分析" class="risk-level">
          <div class="risk-title">风险等级动态分析</div>
          <risk-leve-echarts
            :echartsData="resData.riskDynamicAnalysis"
          ></risk-leve-echarts>
        </div>
        <div title="风险类型动态分析" class="unsafe-type">
          <div class="risk-title">风险类型动态分析</div>
          <unsafe-type-echarts
            :echartsData="resData.riskTypeDynamicAnalysis"
          ></unsafe-type-echarts>
        </div>
      </div>
      <div class="content-center" style="margin-top:10px">
        <hidden-danger-num
          :num="totalRisk"
          msg="区域内风险点"
        ></hidden-danger-num>
        <!-- dv-border-box-8 -->
        <div class="dv-border-box">
          <div class="hidden-danger">
            <div class="item" @click="riskDialog(3, greatRisk)">
              <!-- <div class="icon"></div> -->
              <div class="item-content">
                <div class="title">重大风险</div>
                <div class="number-content">
                    <div class="number">
                      {{ greatRisk }}
                    </div>
                </div>
              </div>
            </div>
            <div class="item" @click="riskDialog(2, largenRisK)">
              <!-- <div class="icon"></div> -->
              <div class="item-content">
                <div class="title">较大风险</div>
                <div class="number-content">
                    <div class="number">
                      {{ largenRisK }}
                    </div>
                </div>
              </div>
            </div>
            <div class="item" @click="riskDialog(1, ordinaryRisk)">
              <!-- <div class="icon"></div> -->
              <div class="item-content">
                <div class="title">一般风险</div>
                <div class="number-content">
                    <div class="number">
                      {{ ordinaryRisk }}
                    </div>
                </div>
              </div>
            </div>
            <div class="item" @click="riskDialog(0, lesserRisk)">
              <!-- <div class="icon"></div> -->
              <div class="item-content">
                <div class="title">低风险</div>
                <div class="number-content">
                    <div class="number">
                      {{ lesserRisk }}
                    </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="map-content">
          <map-content
            :cityArr="cityArr"
            :cityCode="cityCode"
            @refreshData="refreshData"
            :tooltip="tooltip"
            :isbaifen="false"
            :pieces="pieces"
          ></map-content>
        </div>
      </div>
      <div class="content-right">
        <div title="风险比较四色图" class="four-color">
          <div class="four-title">风险比较四色图</div>
          <four-color-echarts
            v-if="resData.riskLevelCompare.length > 0"
            :echartsData="resData.riskLevelCompare"
          ></four-color-echarts>
          <div v-else class="noData">
            暂无数据
          </div>
        </div>

        <school-list
          v-if="this.eduInfo.eduBuresuType != 2"
          :schoolList="schoolList"
          @clickRow="clickRow"
          ref="schoolList"
        ></school-list>
        <school-list-area
          v-else
          :schoolList="schoolList"
          :areaSchoolList="areaSchoolList"
          @clickRow="clickRow"
        ></school-list-area>
      </div>
    </div>
    <risk-dialog
      :type="riskDialogType"
      :show="riskListShow"
      @close="dialogClose"
      :searchParams="searchParams"
    ></risk-dialog>
  </div>
</template>

<script>
import riskLeveEcharts from "./components/riskLeveEcharts";
import unsafeTypeEcharts from "./components/unsafeTypeEchartsRisk";
import fourColorEcharts from "./components/fourColorEcharts";
import theNowTime from "./components/theNowTime";
import hiddenDangerNum from "./components/hiddenDangerNum";
import mapContent from "./components/mapContent";
import riskDialog from "./components/riskDialog";
import schoolList from "./components/riskSchoolList";
import schoolListArea from "./components/riskSchoolListArea";
import CountToComponent from "@/components/CountToComponent";
export default {
  name: "eduRiskStatistics",
  components: {},
  props: {},
  data() {
    return {
      eduInfo: JSON.parse(sessionStorage.getItem("eduInfo")),
      resData: {
        troubleNum: 0,
        subSchoolInfo: [], //直属学校列表
        riskLevelCompare: [], //风险比较四色图
        riskDynamicAnalysis: [], //风险类型动态分析
        riskTypeDynamicAnalysis: [] //风险类型动态分析
      },
      totalRisk: 0, //风险汇总
      greatRisk: 0, //重大风险
      largenRisK: 0, //较大风险
      ordinaryRisk: 0, //一般风险
      lesserRisk: 0, //较低风险
      schoolList: [], //学校列表
      areaSchoolList: [], //乡镇中心校学校列表
      cityArr: [],
      cityCode: "",
      pieces: [
        { gt: 240, label: "重大风险", color: "#FF6464" },
        { gt: 160, lte: 240, label: "较大风险", color: "#FF995A" },
        { gt: 80, lte: 160, label: "一般风险", color: "#E9D74C" },
        { gt: -1, lte: 80, label: "低风险", color: "#6363FF" }
      ],
      tooltip: [
        {
          title: "风险值",
          value: "value"
        }
      ],
      riskListShow: false,
      searchParams: {
        eduId: "",
        regionCode: "",
        eduBuresuType: "",
        riskLevel: 0,
        schoolId: ""
      },
      riskDialogType: "edu"
    };
  },
  created() {},
  mounted() {
    let req = {
      eduId: this.eduInfo.eduId,
      regionCode: parseInt(this.eduInfo.regionCode),
      eduBuresuType: this.eduInfo.eduBuresuType
    };
    this.getStatisticsRiskList(req);
    if (this.eduInfo.eduBuresuType == 2) {
      // 区县获取中心学校列表
      this.getAreaSchoolList();
    }
  },
  components: {
    riskLeveEcharts,
    unsafeTypeEcharts,
    fourColorEcharts,
    theNowTime,
    hiddenDangerNum,
    mapContent,
    riskDialog,
    schoolList,
    schoolListArea,
    CountToComponent
  },
  watch: {},
  methods: {
    refreshData(obj) {
      let req = {
        eduId: obj.eduId,
        regionCode: parseInt(obj.regionCode),
        eduBuresuType: obj.eduBuresuType
      };
      this.getStatisticsRiskList(req);
      if (this.eduInfo.eduBuresuType == 2) {
        // 区县获取中心学校列表
        this.getAreaSchoolList();
      }
      if (this.$refs.schoolList.$refs.rateItem) {
        this.$refs.schoolList.$refs.rateItem.map((item) => {
          return (item.className = "rate-list");
        });
      }
    },
    async getStatisticsRiskList(req) {
      let self = this;
      self.searchParams.eduId = req.eduId;
      self.searchParams.regionCode = req.regionCode;
      self.searchParams.eduBuresuType = req.eduBuresuType;
      self.searchParams.schoolId = "";
      let res = await self.$Http.getStatisticsRiskList(req);
      if (res.code == 200) {
        if (res.data) {
          self.resData = res.data;
          self.schoolList = self.resData.subSchoolInfo || [];
          self.resData.riskTypeDynamicAnalysis = self.resData.riskTypeDynamicAnalysis.filter(
            (item) => {
              return item.totalNum > 0;
            }
          );
          self.getRislNum(self.resData.riskTotal || []);
          self.cityCode = req.regionCode + "";
          let data = res.data.areaMapInfos || [];
          self.cityArr = data.map((item) => {
            item.name = item.regionName;
            item.value = item.maxRiskType;
            return item;
          });
        }
      } else if (res.code == 101) {
      } else {
      }
    },
    async getAreaSchoolList() {
      let req = { eduId: this.eduInfo.eduId };
      let res = await this.$Http.getTowCenterStatistics(req);
      if (res.code == 200) {
        let data = res.data || [];
        data.map((item) => {
          item.isUnfold = false;
          return item;
        });
        this.areaSchoolList = data;
      } else if (res.code == 101) {
        this.areaSchoolList = [];
      } else {
        this.areaSchoolList = [];
      }
    },
    // 点击直属学校
    clickRow(row) {
      if (row.schoolId) {
        this.searchParams.eduId = "";
        this.searchParams.regionCode = "";
        this.searchParams.eduBuresuType = "";
        this.searchParams.schoolId = row.schoolId;
        this.getSchoolRisKInfo(row.schoolId);
      }
    },
    // 点击直属学校查询学校信息
    async getSchoolRisKInfo(schoolId) {
      let req = {
        schoolId: schoolId
      };
      let res = await this.$Http.getSchoolRisKInfo(req);
      if (res.code == 200) {
        if (res.data) {
          this.resData = res.data;
          this.getRislNum(this.resData.riskTotal || []);
        }
      } else if (res.code == 101) {
      } else {
      }
    },
    getRislNum(list) {
      let self = this;
      list.forEach((element) => {
        if (element.totalType == -1) {
          self.totalRisk = element.totalNum || 0; //风险汇总
        } else if (element.totalType == 3) {
          self.greatRisk = element.totalNum || 0; //重大风险
        } else if (element.totalType == 2) {
          self.largenRisK = element.totalNum || 0; //较大风险
        } else if (element.totalType == 1) {
          self.ordinaryRisk = element.totalNum || 0; //一般风险
        } else if (element.totalType == 0) {
          self.lesserRisk = element.totalNum || 0; //较低风险
        }
      });
    },
    riskDialog(val, number) {
      if (number && number != 0) {
        this.searchParams.riskLevel = val;
        if (this.searchParams.schoolId) {
          this.riskDialogType = "school";
        } else {
          this.riskDialogType = "edu";
        }
        this.riskListShow = true;
      } else {
        this.$message("当前区域无" + this.levelNames[val]);
      }
    },
    dialogClose() {
      this.riskListShow = false;
    }
  },
  computed: {
    levelNames() {
      return this.$store.state.select.riskLevel.map((item) => {
        return item.levelNameOne;
      });
    }
  },
  destroyed() {}
};
</script>

<style lang="scss" scoped>
.content {
  // margin-top: 10px;
  display: flex;
  padding: 30px 3.75% 0 3.8%;
  justify-content: space-between;
  .content-left {
    width: 460px;
    .risk-level {
      margin-top: 10px;
      width: 100%;
      height: 300px;
      background: url("~@/assets/img/eduBigRisk2/left-top-bg.png") center center
        no-repeat;
      background-size: 100% 100%;
      .risk-title {
        padding: 10px 18px 0 18px;
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #6ff3fa;
      }
    }
    .unsafe-type {
      margin-top: 10px;
      width: 100%;
      height: 500px;
      background: url("~@/assets/img/eduBigRisk2/left-bottom-bg.png") center
        center no-repeat;
      background-size: 100% 100%;
      .risk-title {
        padding: 16px 18px 0 18px;
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #6ff3fa;
      }
    }
  }
  .content-center {
    text-align: center;
    width: 800px;
    background: url("~@/assets/img/eduBigSituation2/center-bg.png") center
      center no-repeat;
    background-size: 100% 100%;
    .map-content {
      //地图区域
      margin-top: 20px;
      height: 432px;
      width: 750px;
    }
    .dv-border-box {
      margin: 5px auto 0 auto;
      // margin-left: 19%;
      width: 62%;
      height: 60px;
      .hidden-danger {
        //风险数值
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        height: 100%;
        .item {
          // display: flex;
          // flex-direction: row;
          // align-items: center;
          width: 100px;
          // height: 60px;
          z-index: 2;
          cursor: pointer;
          &:nth-child(1) {
            .icon {
              width: 36px;
              height: 42px;
              margin: 4px;
              background: url("~@/assets/img/schoolBigData/hidden_danger_red.png")
                center center no-repeat;
              background-size: 100% 100%;
            }
          }
          &:nth-child(2) {
            .icon {
              width: 36px;
              height: 42px;
              margin: 4px;
              background: url("~@/assets/img/schoolBigData/hidden_danger_oragen.png")
                center center no-repeat;
              background-size: 100% 100%;
            }
          }
          &:nth-child(3) {
            .icon {
              width: 36px;
              height: 42px;
              margin: 4px;
              background: url("~@/assets/img/schoolBigData/hidden_danger_yellow.png")
                center center no-repeat;
              background-size: 100% 100%;
            }
          }
          &:nth-child(4) {
            .icon {
              width: 36px;
              height: 42px;
              margin: 4px;
              background: url("~@/assets/img/schoolBigData/hidden_danger_violet.png")
                center center no-repeat;
              background-size: 100% 100%;
            }
          }
          .item-content {
            // display: flex;
            // flex-direction: column;
            // align-items: center;
            // width: 56px;
            // height: 60px;
            text-align: center;
            .title {
              // width: 56px;
              // height: 30px;
              font-size: 14px;
              color: #c4cdff;
              // display: flex;
              // align-items: flex-end;
            }
            .number-content {
              padding-top: 2px;
              // height: 30px;
              // display: flex;
              // flex-direction: row;
              // justify-content: flex-start;
              .number {
                // width: 56px;
                font-size: 16px;
                color: #d3f6ff;
                font-family: 700;
                // display: flex;
                // align-items: center;
              }
            }
          }
        }
      }
    }
  }
  .content-right {
    width: 460px;

    .four-color {
      margin-top: 10px;
      width: 100%;
      height: 316px;
      // text-align: center;
      background: url("~@/assets/img/eduBigRisk2/left-bottom-bg.png") center
        center no-repeat;
      background-size: 100% 100%;
      
      .four-title {
        padding: 6px 18px 0 18px;
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #6ff3fa;
      }
    }
  }
}
.noData {
  height: 250px;
  width: 100%;
  color: rgba(233, 237, 255, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
